(function () {
    'use strict';

    angular.module("imApp").factory("productionRoutingService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3650,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3651,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
